import { useCallback, useEffect, useState } from 'react'
import { Input, Modal, Typography } from '@musinsa/pbo-core'
import { DELETE_REASON_MAX_BYTES, DELETE_REASON_MIN_BYTES, legacyByteLength } from '@/pages/inventory/stockTransferConfirm/constants'

interface Props {
  open: boolean
  /** 삭제 대상 문서 수 — 안내 문구에 표시한다. */
  documentCount: number
  isDeleting?: boolean
  onConfirm: (reason: string) => void
  onCancel: () => void
}

/**
 * EST04 삭제 사유 모달. (1.0 `ReasonPopUp` 동치 — auth0 전용 삭제 경로)
 *
 * 사유는 BE 가 legacy byte 기준 15~90B(한글 5~30자)를 강제한다(DeleteStockTransferDocumentsUsecase) —
 * 같은 계산식으로 선검증해 400 왕복을 줄이고, 미달/초과를 바이트가 아니라 사람이 읽을 문구로 안내한다.
 */
export function DeleteReasonModal({ open, documentCount, isDeleting, onConfirm, onCancel }: Readonly<Props>) {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (open) setReason('')
  }, [open])

  const bytes = legacyByteLength(reason.trim())
  const isValid = bytes >= DELETE_REASON_MIN_BYTES && bytes <= DELETE_REASON_MAX_BYTES

  const handleOk = useCallback(() => {
    if (!isValid) return
    onConfirm(reason.trim())
  }, [isValid, reason, onConfirm])

  return (
    <Modal
      open={open}
      title="삭제 사유"
      width={560}
      okText="삭제"
      cancelText="취소"
      okDisabled={!isValid || isDeleting}
      onOk={handleOk}
      onCancel={onCancel}
    >
      <Typography.Text>{`선택한 ${documentCount}건의 이동지시문서를 삭제합니다. 사유를 입력해 주세요.`}</Typography.Text>
      <Input.TextArea
        rows={3}
        placeholder="삭제 사유를 입력하세요 (한글 기준 5~30자)"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        style={{ marginTop: 8 }}
      />
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        한글 기준 5자 이상 30자 이하로 입력해주세요.
      </Typography.Text>
    </Modal>
  )
}
